import {ExtractDeliveryNoteDocumentResult} from '@prompt-bridge/shared/validations';

import {precisionCalculation} from 'shared/web';

import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

export function mapDocumentResultToDefaultValues(
  documentResult: ExtractDeliveryNoteDocumentResult | null,
  defaultHandlingUnitId: string | null,
  defaultVatRateType: string | null
): DeliveryNoteDocumentPreviewFormDefinition {
  const basicInformation = {
    supplier: documentResult?.basicInformation?.supplier || '',
    warehouse: '',
    deliveryNoteNumber: documentResult?.basicInformation?.deliveryNoteNumber,
    invoiceNumber: documentResult?.basicInformation?.invoiceNumber,
    authorizationProfile: '',
    paymentType: 'bank_transfer',
    currency: documentResult?.basicInformation?.currency || '',
  };

  const listOfItems =
    documentResult?.listOfItems?.flatMap((page) =>
      page.items.map((item) => ({
        isSelected: true,
        pageNumber: page.pageNumber,
        number: item.catalogueNumber || '',
        lastAutoFilledCatalogNumber: null,
        name: item.name || '',
        manufacturer: '',
        quantity: item.quantity || 0,
        unit: item.unit || defaultHandlingUnitId,
        vat: item.vat || defaultVatRateType,
        unitPrice: item.discount
          ? // Apply discount to unit price (discount 0% = 0, 100% = 1)
            precisionCalculation.round(
              precisionCalculation.multiply(
                item.unitPrice || 0,
                precisionCalculation.subtract(1, item.discount || 0)
              ),
              2
            )
          : precisionCalculation.round(item.unitPrice || 0, 2),
        totalPrice: precisionCalculation.round(item.totalPrice || 0, 2),
        totalPriceWithVat: 0,
      }))
    ) || [];

  return {
    basicInformation,
    listOfItems,
  };
}
